<template>
  <div class=" bg-green-100 p-3">
    <div class="inline-block text-4xl">PALMS Paper Analysis System</div>
    <div class=" float-right">
      <div v-if="API.Token.JWT">
        <div class="p-3">Welcome Back! @{{ API.Token.Profile.username }}</div>
      </div>
    </div>
    <div>
      <router-link active-class="bg-green-600 text-white" class="bg-green-200 inline-block p-2 ml-0 m-1" to="/pdf/home"><div class="inline-block cursor-pointer">Home</div></router-link>
      <router-link active-class="bg-green-600 text-white" class="bg-green-200 inline-block p-2 m-1" v-if="API.Token.JWT" to="/pdf/dash"><div class="inline-block cursor-pointer">PDF Dashbaord</div></router-link>
      <router-link active-class="bg-green-600 text-white" class="bg-green-200 inline-block p-2 m-1" v-if="!API.Token.JWT" to="/pdf/login"><div class="inline-block cursor-pointer">Login</div></router-link>
      <div class="inline-block float-right" v-if="API.Token.JWT" @click="logout()"><div class="inline-block p-2 m-1 border bg-gray-200 cursor-pointer">Logout</div></div>
    </div>
  </div>
</template>

<script>
import * as API from '../pdfAPI'
export default {
  data () {
    return {
      API
    }
  },
  computed: {
  },
  methods: {
    logout () {
      API.logout()
      this.$forceUpdate()
      this.$router.push('/pdf')
    }
  }
}
</script>

<style>

</style>
